import { render, staticRenderFns } from "./sensor.vue?vue&type=template&id=3b0771e2&scoped=true&"
import script from "./sensor.vue?vue&type=script&lang=js&"
export * from "./sensor.vue?vue&type=script&lang=js&"
import style0 from "./sensor.vue?vue&type=style&index=0&id=3b0771e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0771e2",
  null
  
)

export default component.exports